import type { HelpFile } from '../../types/help'
import { CalendarTestIds } from '../../../testids/CalendarTestIds'

export const calendarHelp: HelpFile = {
  docPage: '/docs/reference/calendar',
  texts: {
    [CalendarTestIds.calendarLabel]:
      'Current month and year — click to switch between month, year, and decade views.',
    [CalendarTestIds.calendarPrevMonth]: null,
    [CalendarTestIds.calendarNextMonth]: null,
    [CalendarTestIds.calendarPrevYear]: null,
    [CalendarTestIds.calendarNextYear]: null,
    [CalendarTestIds.calendarPrevDecade]: null,
    [CalendarTestIds.calendarNextDecade]: null,
    [CalendarTestIds.calendarYearRange]: null,
  },
}
